module.exports = __webpack_public_path__ + "images/36bc68705db4bb82eb73d4984664d3f1-bedroom-fullcarcass.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/bedroom-fullcarcass.jpg
// module id = ./src/assets/images/content/bedroom-fullcarcass.jpg
// module chunks = 0